"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextContent = exports.TextLink = exports.Heading4 = exports.Heading3 = exports.Heading2 = exports.Heading1 = exports.Text = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _core = require("@emotion/core");

var _styledSystem = require("styled-system");

var _themeGet = require("@styled-system/theme-get");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const textTransform = (0, _styledSystem.system)({
  textTransform: true
});
const width = (0, _styledSystem.system)({
  width: {
    property: 'width',
    scale: 'sizes'
  }
});
const BaseText = ( /*#__PURE__*/0, _styledBase.default)('div', {
  target: "e4p1v730",
  label: "BaseText"
})("margin:0;", (0, _styledSystem.compose)(_styledSystem.space, width, _styledSystem.color, _styledSystem.typography), _styledSystem.fontWeight, textTransform);

const setSizeFonts = props => {
  if (props.fontSize) {
    return '';
  }

  switch (props.size) {
    case 'small':
      return /*#__PURE__*/(0, _core.css)("font-size:", (0, _themeGet.themeGet)('fontSizes.small')(props), ";");

    case 'large':
      return /*#__PURE__*/(0, _core.css)("font-size:", (0, _themeGet.themeGet)('fontSizes.large')(props), ";");

    case 'xlarge':
      return /*#__PURE__*/(0, _core.css)("font-size:", (0, _themeGet.themeGet)('fontSizes.xlarge')(props), ";");

    case 'normal':
    default:
      return '';
  }
};

const setSizeLineHeight = props => {
  if (props.lineHeight) {
    return '';
  }

  switch (props.size) {
    case 'small':
      return /*#__PURE__*/(0, _core.css)("line-height:", (0, _themeGet.themeGet)('lineHeights.3')(props), ";");

    case 'large':
      return /*#__PURE__*/(0, _core.css)("line-height:", (0, _themeGet.themeGet)('lineHeights.5')(props), ";");

    case 'xlarge':
      return /*#__PURE__*/(0, _core.css)("line-height:", (0, _themeGet.themeGet)('lineHeights.6')(props), ";");

    case 'normal':
      return /*#__PURE__*/(0, _core.css)("line-height:", (0, _themeGet.themeGet)('lineHeights.4')(props), ";");

    default:
      return '';
  }
};
/**
 * The essence of written communication, beautifully styled for all your legibility needs.
 * Basic text component that contains utility properties to adjust typographic styling
 */


const Text = ( /*#__PURE__*/0, _styledBase.default)('p', {
  target: "e4p1v731",
  label: "Text"
})("margin:0;", (0, _styledSystem.compose)(_styledSystem.space, width, _styledSystem.color, _styledSystem.typography), setSizeFonts, setSizeLineHeight, _styledSystem.fontWeight, textTransform);
exports.Text = Text;
Text.defaultProps = {
  className: 'fl-text'
};
/**
 * Pre-styled h1 component
 */

const Heading1 = ( /*#__PURE__*/0, _styledBase.default)(BaseText, {
  target: "e4p1v732",
  label: "Heading1"
})("font-size:", (0, _themeGet.themeGet)('fontSizes.xxlarge'), ";line-height:", (0, _themeGet.themeGet)('lineHeights.9'), ";").withComponent('h1', {
  target: "e4p1v738",
  label: "Heading1"
});
exports.Heading1 = Heading1;
Heading1.defaultProps = _objectSpread(_objectSpread({}, BaseText.defaultProps), {}, {
  fontWeight: 'bold',
  color: 'textHeading',
  className: 'fl-heading1'
});
/**
 * Pre-styled h2 component
 */

const Heading2 = ( /*#__PURE__*/0, _styledBase.default)(BaseText, {
  target: "e4p1v733",
  label: "Heading2"
})("font-size:", (0, _themeGet.themeGet)('fontSizes.xlarge'), ";line-height:", (0, _themeGet.themeGet)('lineHeights.6'), ";").withComponent('h2', {
  target: "e4p1v739",
  label: "Heading2"
});
exports.Heading2 = Heading2;
Heading2.defaultProps = _objectSpread(_objectSpread({}, BaseText.defaultProps), {}, {
  fontWeight: 'bold',
  color: 'textHeading',
  className: 'fl-heading2'
});
/**
 * Pre-styled h3 component
 */

const Heading3 = ( /*#__PURE__*/0, _styledBase.default)(BaseText, {
  target: "e4p1v734",
  label: "Heading3"
})("font-size:", (0, _themeGet.themeGet)('fontSizes.large'), ";line-height:", (0, _themeGet.themeGet)('lineHeights.5'), ";").withComponent('h3', {
  target: "e4p1v7310",
  label: "Heading3"
});
exports.Heading3 = Heading3;
Heading3.defaultProps = _objectSpread(_objectSpread({}, BaseText.defaultProps), {}, {
  fontWeight: 'bold',
  color: 'textHeading',
  className: 'fl-heading3'
});
/**
 * Pre-styled h4 component
 */

const Heading4 = ( /*#__PURE__*/0, _styledBase.default)(BaseText, {
  target: "e4p1v735",
  label: "Heading4"
})("font-size:", (0, _themeGet.themeGet)('fontSizes.xsmall'), ";line-height:", (0, _themeGet.themeGet)('lineHeights.3'), ";text-transform:uppercase;").withComponent('h4', {
  target: "e4p1v7311",
  label: "Heading4"
});
exports.Heading4 = Heading4;
Heading4.defaultProps = _objectSpread(_objectSpread({}, BaseText.defaultProps), {}, {
  fontWeight: 'bold',
  color: 'textHeading',
  letterSpacing: 3,
  className: 'fl-heading4'
});

const textlinkColor = props => props.color ? (0, _themeGet.themeGet)("colors.".concat(props.color), props.color)(props) : (0, _themeGet.themeGet)('textStyles.link.color')(props);
/**
 * Pre-styled anchor component
 */


const TextLink = ( /*#__PURE__*/0, _styledBase.default)(Text, {
  target: "e4p1v736",
  label: "TextLink"
})("color:", textlinkColor, ";text-decoration:none;&:hover{text-decoration:underline;cursor:pointer;color:", textlinkColor, ";}", _styledSystem.color, ";").withComponent('a', {
  target: "e4p1v7312",
  label: "TextLink"
});
exports.TextLink = TextLink;
TextLink.defaultProps = {
  className: 'fl-textlink'
};
const TextContent = ( /*#__PURE__*/0, _styledBase.default)('div', {
  target: "e4p1v737",
  label: "TextContent"
})(".fl-text:not(:last-child),.fl-textlink:not(:last-child){margin-bottom:", (0, _themeGet.themeGet)('space.3'), ";}.fl-heading1:not(:last-child),.fl-heading2:not(:last-child){margin-bottom:", (0, _themeGet.themeGet)('space.2'), ";}.fl-heading3:not(:last-child),.fl-heading4:not(:last-child){margin-bottom:", (0, _themeGet.themeGet)('space.1'), ";}.fl-text:not(:first-of-type),.fl-textlink:not(:first-of-type),.fl-heading1:not(:first-of-type),.fl-heading2:not(:first-of-type),.fl-heading3:not(:first-of-type),.fl-heading4:not(:first-of-type){padding-top:", (0, _themeGet.themeGet)('space.1'), ";}");
exports.TextContent = TextContent;